import React, { useEffect } from "react"
import Block from "@bappweb/block"
import Element from "@bappweb/element"
import MainForm from "./form"
import LandingHeader from "./landingheader"
import SssList from "./ssslist"
import Notes from "./notes"
import { useAppDispatch } from "../../../config/hook"
import { setIsDetails } from "src/projects/kredi-karti/state/isDetails"
import { pushGtmValues } from "@bappweb/utils"

const Landing = () => {
    const dispatch = useAppDispatch()
    dispatch(
        setIsDetails({
            isDetails: false
        })
    )
    useEffect(() => {
        pushGtmValues({
            event: "virtual_page_view",
            content_group: "ticari_kredi_karti",
            pageName: "/basvuru/ticari-kredi-karti/0/landing",
            pageTitle: "Ticari Kredi Kartı"
        })
    }, []);

    return (
        <Block>
            <LandingHeader />
            <MainForm />
            <Notes />
            <SssList />
        </Block>
    )
}

export default Landing
